<section class="no-devices">
    <h1>{{ 'NO_TRACKERS_HAVE' | translate }}</h1>
    <p>{{ 'NO_TRACKERS_HAVE_DESC' | translate }}</p>
</section>
